import { render, staticRenderFns } from "./adrg2.vue?vue&type=template&id=a025b204&scoped=true"
import script from "./adrg2.vue?vue&type=script&lang=js"
export * from "./adrg2.vue?vue&type=script&lang=js"
import style0 from "./adrg2.vue?vue&type=style&index=0&id=a025b204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a025b204",
  null
  
)

export default component.exports